import React from "react";
import myEbscoDataPrivacyMessages from "./my-ebsco-data-privacy-messages";
import { injectIntl, FormattedMessage } from "react-intl";
import { EBSCO_URLS } from "../../../../constants";
import { Hyperlink } from "@ebsco-ui/ebsco-ui";
import "./my-ebsco-data-privacy.scss";
import DataPrivacyContent from "./data-privacy-content";
import { getFeatureFlagData } from "../../../store/feature-flag";
import { getFeatureFlagFromStore } from "../../../store/feature-flag/get-feature-flag-from-store";
import { FEATURE_FLAGS } from "../../../../constants";
import { useSelector } from "react-redux";

const MyEbscoDataPrivacy = ({ intl: { formatMessage }, isCoppa }) => {
  const featureFlagsData = useSelector(getFeatureFlagData);
  const isFeatureFlagOn = getFeatureFlagFromStore(
    featureFlagsData,
    FEATURE_FLAGS.C9823_ACCOUNT_INACTIVITY_MESSAGE
  );

  const block = "my-ebsco-data-privacy";
  const privacyPolicyData = () => {
    return (
      <FormattedMessage
        {...myEbscoDataPrivacyMessages.myEbscoDataPrivacyPolicy}
        values={{
          a: displayPrivacyPolicyLink(block)
        }}
      />
    );
  };
  const dataPrivacyMessages = [
    isCoppa
      ? myEbscoDataPrivacyMessages.myEbscoDataPrivacyDataCoppaBulletOne
      : myEbscoDataPrivacyMessages.myEbscoDataPrivacyDataNonCoppaBulletOne,
    myEbscoDataPrivacyMessages.myEbscoDataPrivacyDataBulletTwo,
    myEbscoDataPrivacyMessages.myEbscoDataPrivacyDataBulletThree,
    myEbscoDataPrivacyMessages.myEbscoDataPrivacyDataBulletFour
  ];

  const dataPrivacyBullets = dataPrivacyMessages.map(privacyMessages => (
    <li key={privacyMessages.id}>{formatMessage(privacyMessages)}</li>
  ));

  const myEbscoDataPrivacyDescription = () => {
    return (
      <div className={`${block}__data-privacy-description`}>
        <h2>{formatMessage(myEbscoDataPrivacyMessages.dataPrivacyHeading)}</h2>
        <p>{formatMessage(myEbscoDataPrivacyMessages.dataPrivacyBody)}</p>
        <DataPrivacyContent
          className="prompt__section-title"
          privacyHeading={myEbscoDataPrivacyMessages.whyIsDataCollectedHeading}
          privacyBody={myEbscoDataPrivacyMessages.whyIsDataCollectedBody}
        />
        <DataPrivacyContent
          className="prompt__section-title"
          privacyHeading={myEbscoDataPrivacyMessages.howItIsUsedHeading}
          privacyBody={myEbscoDataPrivacyMessages.howItIsUsedBody}
        />
      </div>
    );
  };

  return isCoppa ? (
    <div className={`${block}__data-privacy-main-content`}>
      {myEbscoDataPrivacyDescription()}
      <ul className={`${block}__bullet_points`}>{dataPrivacyBullets}</ul>
      {privacyPolicyData()}
    </div>
  ) : (
    <div className={`${block}__data-privacy-main-content`}>
      {myEbscoDataPrivacyDescription()}
      <ul className={`${block}__bullet_points`}>{dataPrivacyBullets}</ul>
      {privacyPolicyData()}
      <DataPrivacyContent
        className="prompt__section-title"
        privacyHeading={myEbscoDataPrivacyMessages.youControlYourDataHeading}
        privacyBody={myEbscoDataPrivacyMessages.youControlYourDataBody}
      />
      {isFeatureFlagOn && (
        <DataPrivacyContent
          className="prompt__section-title"
          privacyHeading={myEbscoDataPrivacyMessages.accountInactivityHeading}
          privacyBody={myEbscoDataPrivacyMessages.accountInactivityBody}
        />
      )}
    </div>
  );
};

const displayPrivacyPolicyLink = baseClassName => msg => (
  <Hyperlink
    className={`${baseClassName}__privacy_policy`}
    href={EBSCO_URLS.PRIVACY_POLICY}
    target="_blank"
  >
    {msg}
  </Hyperlink>
);

export { MyEbscoDataPrivacy };
export default injectIntl(MyEbscoDataPrivacy);
